import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createLocation } from '../../api/production-request-api/index.js';
import { toast } from '@pella/sash-framework';
import { QUERY_KEYS } from '../../data/constants';

/**
 * Hook containing mutation function for creating a Location.
 */
export const useCreateLocation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    /**
     * mutateFn - Function to call createLocation.
     * @param {Pella.ProductionRequestAPI.CreateLocationInput} input - The inputs for creating the Location.
     */
    mutationFn: (input) => createLocation(input),
    onSuccess: () => {
      toast.success('Location created successfully!');
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.LOCATION_DATA] });
    },
  });
};
